import { Fragment } from 'react/jsx-runtime';

// Components
import Heading from '@/components/atoms/Heading/Heading';
import Button from '@/components/atoms/Button/Button';
import CmsImage from '@/components/atoms/CmsImage/CmsImage';

// Hooks
import useResponsive from '@/hooks/useResponsive';

// Other
import { type SectionEnTeteType } from '@/services/blocksSchema';

// Style
import styles from './SectionEnTete.module.css';

interface SectionEnTeteProps {
  title: SectionEnTeteType['title'];
  cover: SectionEnTeteType['cover'],
  checklist: SectionEnTeteType['checklist'],
  button: SectionEnTeteType['button'],
  keyFigures: SectionEnTeteType['keyFigures'],
}

function SectionEnTete({
  title,
  cover,
  checklist,
  button,
  keyFigures
}: SectionEnTeteProps) {
  const { isMobile } = useResponsive();

  return (
    <div className={styles.relative}>
      {/* Cover */}
      {
        cover?.[0] && (
          <>
            <CmsImage
              media={cover[0]}
              sizes="100vw"
              priority
              alt={cover[0].alternativeText ?? ''}
              className={styles.cover}
            />
            <div className={styles['cover-overlay']} />
          </>
        )
      }
      <div className={styles.container}>
        <div className={styles.content}>
          <div className={styles.heading}>
            <Heading
              title={title}
              isSharp
            />
          </div>
          {/* Checklist */}
          <div className={styles.checklist}>
            {
              checklist.map((item) => (
                <div key={item.text} className={styles['checklist-item']}>
                  <CmsImage media={item.icon} sizes="24px" width={24} height={24} />
                  {item.text}
                </div>
              ))
            }
          </div>
          {/* Button */}
          <div className={styles.button}>
            <Button
              title={button.title}
              bgColor='red'
              url={button.url}
            />
          </div>
        </div>
        {/* Key figures */}
        <div className={styles['key-figures']}>
          {
            keyFigures.map((item) => (
              <Fragment key={item.title}>
                <div className={styles['key-figures-item']}>
                  <Heading 
                    title={item.title}
                    Tag={isMobile ? 'h6' : 'h2'}
                    size={isMobile ? 'h4' : 'h2'}
                  />
                  <p className={styles['key-figures-description']}>
                    {item.description}
                  </p>
                </div>
                <div className={styles['key-figures-line']} />
              </Fragment>
            ))
          }
        </div>
      </div>
    </div>
  );
}

export default SectionEnTete;
